import type { ValidStorageValue } from '@/managers/Storage';
import { idbKeyValWrapper } from '@/managers/Storage/indexedDBWrapper';
import { sessionStorageWrapper, localStorageWrapper } from '@/utils/browser-state';

type UserPreferenceMemoryStore = {
  [key: string]: ValidStorageValue,
};

export type UserPreferenceStorageMethod = 'indexedDB' | 'sessionStorage' | 'localStorage' | 'inMemory';

const inMemory = {
  data: {} as UserPreferenceMemoryStore,
  get: function(name: string) {
    return this.data[name] ?? null;
  },
  set: function(name: string, value: ValidStorageValue) {
    this.data[name] = value;
  },
  remove: function(_name: string) {
    delete this.data[_name];
  },
};

export const getMethodWrapper = (method: UserPreferenceStorageMethod) => {
  return method === 'inMemory' ?
    inMemory :
    method === 'sessionStorage' ?
      sessionStorageWrapper :
      method === 'localStorage' ?
        localStorageWrapper :
        idbKeyValWrapper;
};

export default class UserPreference {
  keyName: string;

  method: {
    get: (_name: string) => ValidStorageValue | null | Promise<ValidStorageValue | null>;
    set: (_name: string, _value: ValidStorageValue) => void;
    remove: (_name: string) => void;
  };

  constructor(name: string, method: UserPreferenceStorageMethod = 'indexedDB') {
    const prefix = method !== 'indexedDB' ? 'PbsKidsPuma.UserPref.' : '';
    this.keyName = prefix + name;
    this.method = getMethodWrapper(method);
  }

  set(value: ValidStorageValue) {
    this.method.set(this.keyName, value);
  }

  get() {
    return this.method.get(this.keyName);
  }

  delete() {
    this.method.remove(this.keyName);
  }
}
